/**
 * 格式化文件名
 * @param fileUrl 文件地址
 * @returns string 文件名
 */
export const findIndex = 0
export function formatFileUrl(fileUrl) {
  fileUrl = fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
  const fileName = fileUrl.substring(0, fileUrl.lastIndexOf('_'))
  const fileType = fileUrl.substring(fileUrl.lastIndexOf('_'))
  return fileName + fileType
}
